import { render, staticRenderFns } from "./CreateWaitQT.vue?vue&type=template&id=25a59e08&"
import script from "./CreateWaitQT.vue?vue&type=script&lang=js&"
export * from "./CreateWaitQT.vue?vue&type=script&lang=js&"
import style0 from "./CreateWaitQT.vue?vue&type=style&index=0&id=25a59e08&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports